export const getTitle = (type) => {
  if (type === "unity_collect") return "somente na Unidade";
  if (type === "home_collect") return "somente em Casa";

  return "em casa ou na unidade";
};
